export default "__VITE_ASSET__D37zrAIr__"